import ArticleTemplate from '@/pages/article/components/ArticleTemplate';

export default function ArticleReview() {
  return <ArticleTemplate slug="sugargoo-spreadsheet-review" />;
}